let Step = /*#__PURE__*/function (Step) {
  Step["SEARCH_INFO"] = "SEARCH_INFO";
  Step["SERVICE_SELECTION"] = "SERVICE_SELECTION";
  Step["SHIPPING_DETAILS"] = "SHIPPING_DETAILS";
  Step["BILLING_INFO"] = "BILLING_INFO";
  Step["PAYMENT"] = "PAYMENT";
  Step["PURCHASED"] = "PURCHASED";
  return Step;
}({});

export { Step };
//# sourceMappingURL=ProShipment.js.map
